import { Trans } from 'react-i18next';

import { Body1, Stack } from '@myphx-engineering/phx-design-system';

export const ContentSection = ({ content }: { content: string[] }) => (
    <Stack gap="xs">
        {content.map((line) => (
            <Body1 key={line}>
                <Trans
                    ns="dynamic"
                    components={{ b: <strong />, br: <br /> }}
                    defaults={line}
                />
            </Body1>
        ))}
    </Stack>
);
